class InstructorCreatePassFailReportCardController {
  constructor(
    $state,
    $stateParams,
    DrivesModel,
    FlashService,
    ReportcardsModel,
    student,
  ) {
    this.reportcard = {
      student: {
        firstname: student.firstname,
        lastname: student.lastname,
      },
    };

    this.drive = [];
    this.tasks = [];
    this.grades = [];
    this.gradeIncomplete = true;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.ReportcardsModel = ReportcardsModel;
    this.FlashService = FlashService;

    DrivesModel.getDriveByID($stateParams.driveId).then((response) => {
      this.drive = response.drive;
      this.driveDate = new Date(
        this.drive.drive_date + " " + this.drive.start_time,
      );
      const now = new Date();
      const diff = this.driveDate.getTime() - now.getTime();
      const isInPast = diff < 0;
      const absDiff = Math.abs(diff);
      const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );

      if (days > 0) {
        this.untilDrive = isInPast
          ? `${days} day${days > 1 ? "s" : ""} ago`
          : `in ${days} day${days > 1 ? "s" : ""}`;
      } else if (hours > 0) {
        this.untilDrive = isInPast
          ? `${hours} hour${hours > 1 ? "s" : ""} ago`
          : `in ${hours} hour${hours > 1 ? "s" : ""}`;
      } else {
        this.untilDrive = isInPast ? "a few moments ago" : "in a few moments";
      }
    });
  }

  submitGrade(grade) {
    const data = {
      drive_id: this.$stateParams.driveId,
      student_id: this.$stateParams.studentId,
      grade: grade,
    };

    this.ReportcardsModel.submitPassFailGrade(data).then((response) => {
      this.FlashService.setMessage({
        type: "success",
        message: response.message,
      });
      if (response.redirect === "dashboard") {
        this.$state.go("drivecoach.instructor.dashboard");
      }
      if (response.redirect === "drive") {
        this.$state.go("drivecoach.instructor.dashboard.drive", {
          driveId: this.drive.id,
        });
      }
    });
  }
}
InstructorCreatePassFailReportCardController.$inject = [
  "$state",
  "$stateParams",
  "DrivesModel",
  "FlashService",
  "ReportcardsModel",
  "student",
];

export default InstructorCreatePassFailReportCardController;
